import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import parseSessionStorageVariable from '../../helpers/utils/parseSessionStorage';

const Filters = ({ onFiltersChange }) => {
  const roles = useSelector((state) => state?.static?.roles);
  const [localFilters, setLocalFilters] = useState({
    SCO: parseSessionStorageVariable('filter_SCO') === 'true',
    SAV: parseSessionStorageVariable('filter_SAV') === 'true',
    SLO: parseSessionStorageVariable('filter_SLO') === 'true',
    Operateur: parseSessionStorageVariable('filter_Operateur') === 'true',
    Responsable: parseSessionStorageVariable('filter_Responsable') === 'true',
    Inactif: parseSessionStorageVariable('filter_Inactif') === 'true',
    Autres: parseSessionStorageVariable('filter_Autres') === 'true',
  });

  const handleFilterChange = useCallback(
    (event) => {
      setLocalFilters({
        ...localFilters,
        [event.target.value]: event.target.checked,
      });
    },
    [localFilters]
  );

  useEffect(() => {
    if (roles) {
      const filteredRoleIds = [];
      const isAnyFilterSelected =
        localFilters.SCO ||
        localFilters.SAV ||
        localFilters.SLO ||
        localFilters.Operateur ||
        localFilters.Responsable ||
        localFilters.Autres;

      if (!isAnyFilterSelected) {
        // Si aucun filtre n'est sélectionné, ajouter tous les IDs de rôles
        roles.forEach((role) => filteredRoleIds.push(role._id));
      } else {
        const addRolesByPrefix = (prefix, services) => {
          if (services.some((service) => localFilters[service])) {
            services.forEach((service) => {
              if (localFilters[service]) {
                roles.forEach((role) => {
                  if (role.name.startsWith(`${prefix} ${service}`)) {
                    filteredRoleIds.push(role._id);
                  }
                });
              }
            });
          } else if (localFilters[prefix.replace(' ', '')]) {
            // If 'Operateur' or 'Responsable' is checked globally
            roles.forEach((role) => {
              if (role.name.startsWith(prefix)) {
                filteredRoleIds.push(role._id);
              }
            });
          }
        };

        addRolesByPrefix('Operateur', ['SCO', 'SAV', 'SLO']);
        addRolesByPrefix('Responsable', ['SCO', 'SAV', 'SLO']);

        if (localFilters.Autres) {
          roles.forEach((role) => {
            if (
              [
                'Operateur Image',
                'Operateur Marketing',
                'Operateur Achat',
                'Operateur Finance',
                'Dirigeant',
                'Administrateur',
              ].includes(role.name)
            ) {
              filteredRoleIds.push(role._id);
            }
          });
        }
      }

      const uniqueRoleIds = [...new Set(filteredRoleIds)];
      onFiltersChange(uniqueRoleIds, localFilters.Inactif);
    }
  }, [localFilters, roles, onFiltersChange]);

  useEffect(() => {
    sessionStorage.setItem('filter_SCO', localFilters.SCO);
    sessionStorage.setItem('filter_SAV', localFilters.SAV);
    sessionStorage.setItem('filter_SLO', localFilters.SLO);
    sessionStorage.setItem('filter_Operateur', localFilters.Operateur);
    sessionStorage.setItem('filter_Responsable', localFilters.Responsable);
    sessionStorage.setItem('filter_Inactif', localFilters.Inactif);
    sessionStorage.setItem('filter_Autres', localFilters.Autres);
  }, [localFilters]);

  return (
    <Paper
      elevation={1}
      sx={{
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
      }}
    >
      <Box>
        <Typography variant="subtitle2">Service</Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={localFilters?.SCO}
                onChange={handleFilterChange}
                value={'SCO'}
              />
            }
            label="SCO"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={localFilters?.SAV}
                onChange={handleFilterChange}
                value={'SAV'}
              />
            }
            label="SAV"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={localFilters?.SLO}
                onChange={handleFilterChange}
                value={'SLO'}
              />
            }
            label="SLO"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={localFilters?.Autres}
                onChange={handleFilterChange}
                value={'Autres'}
              />
            }
            label="Autres"
          />
        </FormGroup>
      </Box>
      <Box>
        <Typography variant="subtitle2">Utilisateur</Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={localFilters?.Operateur}
                onChange={handleFilterChange}
                value={'Operateur'}
                disabled={localFilters?.Responsable}
              />
            }
            label="Operateur"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={localFilters?.Responsable}
                onChange={handleFilterChange}
                value={'Responsable'}
                disabled={localFilters?.Operateur}
              />
            }
            label="Responsable"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={localFilters?.Inactif}
                onChange={handleFilterChange}
                value={'Inactif'}
              />
            }
            label="Inactif"
          />
        </FormGroup>
      </Box>
    </Paper>
  );
};

export default Filters;
